function SectionLocation() {
    return (
        <>
            <h4 className="section-head-small mb-4">Location</h4>
            <div className="twm-s-map-iframe">
                <iframe title="Zozo Jobs Tirupati Location Map" height={270} src="https://www.google.com/maps?q=Tirupati&output=embed" />
            </div>
        </>
    )
}

export default SectionLocation;
